export default __webpack_public_path__ + "static/media/dropdownicon_up.b8c820e8.png";